import { Injectable, NgZone } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CommonDataService } from '@shared/services/common-data.service';
import { Auth } from 'aws-amplify';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  pageName: any;
  constructor(
    private commonServices: CommonDataService, private zone: NgZone, private router: Router ){
      
  }

  // sec2Auth:any = this.commonServices.checkAuth;
  //   auth2:boolean = this.sec2Auth.activeFlag;

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): 
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
  {
    
    return Auth.currentAuthenticatedUser().then(() => {
     
        const getAccess = this.commonServices.checkAuth;
        if(!getAccess.value){
          this.commonServices.checkAuth.next(JSON.parse(window.localStorage.getItem("mp-serve-auth") || "[]"));
          this.commonServices.userData.next(JSON.parse(window.localStorage.getItem("mpuserdetailslock") || "[]"));
          this.commonServices.userInfo.next(JSON.parse(window.localStorage.getItem("mpUInfo") || "[]"));
        }
        this.pageName = route.data['pageName'];
        const userData = this.commonServices.userData.value;
        if(this.pageName){
          const getSectionName = userData.filter((item: any) => item.hasOwnProperty("sectionName") && item.sectionName === this.pageName);
        if((getAccess && getSectionName[0].permissionName == "READ/WRITE") || (getAccess && getSectionName[0].permissionName == "READ ONLY")){
          return true
        }else{
          return false
        }
        }else{
          return true
        }
      
    }).catch(() => {
      return false;
    });
  }
  
}
